import { useQuery } from '@tanstack/react-query';
import { stockApi, signalApi } from '../api/client';
import type { TimeInterval } from '../../shared';

export function useStockQuote(ticker: string) {
  return useQuery({
    queryKey: ['stock', 'quote', ticker],
    queryFn: () => stockApi.getQuote(ticker),
    enabled: !!ticker,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}

export function useStockHistory(ticker: string, interval: TimeInterval = '1d', range: string = '1mo') {
  return useQuery({
    queryKey: ['stock', 'history', ticker, interval, range],
    queryFn: () => stockApi.getHistory(ticker, interval, range),
    enabled: !!ticker,
    staleTime: interval === '1h' ? 60 * 60 * 1000 : 24 * 60 * 60 * 1000,
  });
}

export function useStockProfile(ticker: string) {
  return useQuery({
    queryKey: ['stock', 'profile', ticker],
    queryFn: () => stockApi.getProfile(ticker),
    enabled: !!ticker,
    staleTime: 24 * 60 * 60 * 1000, // 24 hours
  });
}

export function useSignalOverview(ticker: string) {
  return useQuery({
    queryKey: ['signal', 'overview', ticker],
    queryFn: () => signalApi.getOverview(ticker),
    enabled: !!ticker,
    staleTime: 5 * 60 * 1000,
  });
}

export function useDetailedSignal(ticker: string) {
  return useQuery({
    queryKey: ['signal', 'detailed', ticker],
    queryFn: () => signalApi.getDetailed(ticker),
    enabled: !!ticker,
    staleTime: 5 * 60 * 1000,
  });
}
